export const environment = {
    production: true,
    baseApiUrl: 'https://api.kunzad2.fast.com.ph/kunzad-bkdev/api'
};